import constants from "../../../constants";
import MenuBarFooter from "./MenuBarFooter";
import MenuSvgIcon from "../../../Svg/MenuSvgIcon";
import PlusIconSvg from "../../../Svg/PlusIconSvg";
import { getDataFromStorage } from "../../../util";
import MinusIconSvg from "../../../Svg/MinusIconSvg";
import React, { useContext, useEffect,useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import AlertContext from "../../../context/AlertContext";
import CompanyLogo from "../../CommonComponents/CompanyLogo";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import MenuBarHooks from "../../../Hooks/MenuBar/MenuBarHooks";
import Loading from "../../Notification-Loading/Loading/Loading";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import Tooltip from "../../CommonComponents/Tooltip";
import SharePublicProfileButton from "../../PublicProfile/SharePublicProfileButton";

export default function MenuBar() {
  // console.log("Menu Bar Triggered");
  const companyId = parseInt(localStorage.getItem("companyId"));
  const stored = localStorage.getItem("account_response");
  const [enabledFeatures,setEnableFeatures]=useState([])

  useEffect(()=>{
    if (stored) {
    try {
      const decoded = JSON.parse(atob(stored));

      // axios response structure
      const selectedCompany = decoded || {};

      // const companyId = parseInt(localStorage.getItem("companyId"));

      // const selectedCompany = companies.find(c => c.id === companyId);

      if (selectedCompany && selectedCompany.premium_features) {
        const features = JSON.parse(selectedCompany.premium_features);

        setEnableFeatures(features.map(
          (feature) => feature.premium_feature_name??feature.premium_features??feature.name
        ));
        localStorage.setItem(
          "enabled_features",
          btoa(JSON.stringify(features))
        );

      }

    } catch (error) {
      console.error("Error decoding accounts_response:", error);
    }
  }
  },[])
  

  // Feature flags

  const isPremiumCompany = companyId==1 ;
  // console.log("\n\n\n\n-----------enabledFeatures-------\n\n\n\n",enabledFeatures);
  // console.log("companyid:",companyId);

  // menu visibility checks


  const hasCodingChallenges = enabledFeatures.includes("coding_challenges");

  const hasMockTests =
    enabledFeatures.includes("mcq") ||
    enabledFeatures.includes("descriptive") ||
    enabledFeatures.includes("coding_challenge_test") ||
    enabledFeatures.includes("video_test");

  // console.log("mock test : ",hasMockTests);

  const hasAIInterviews = enabledFeatures.includes("ai_interviews");

  const hasJobs = enabledFeatures.includes("jobs_internships");

  const hasHackathons = enabledFeatures.includes("hackathons");

  const showPracticeMenu =(hasCodingChallenges || hasMockTests || hasAIInterviews);

  const showExploreMenu =(hasJobs || hasHackathons);

  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const MenuBarHks = MenuBarHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();



  const { lpid, mid } = useParams();
  const isPreviewLp = new URLSearchParams(window.location.search).get("mode") === "previewlp";

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/main") Alert.navigate("/main/landing");
  }, [pathname, Alert]);

  useEffect(() => {
    if (MenuBarHks.activeBatchRef.current) {
      MenuBarHks.activeBatchRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }, [MenuBarHks.activeBatchRef.current]);

  useEffect(() => {
    Alert.setLpData({});
    // Alert.setIsLoaded(true);
    if (isPreviewLp) {
      Alert.navigate(`/preview/home/${lpid}/module/learningpath?mode=previewlp`);
    } else {

      let api = `node/learner/batch?company_id=${companyId}`;

      if (!companyId || companyId == null) {
        return Alert.navigate("/company");
      }

      axios
        .get(api, useCommonFunctionHks.getHeaderDetailsForAxios())
        .then((res) => {
          if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
            Alert.setShowNotify({
              show: true,
              title: "Error",
              msg: res.data.msg,
            });
            Alert.setIsJoinZoom(
              res.data.data.join_zoom
            ); /* TODO: Zoom Integration */
          } else {
            if (
              res.data?.data?.[0]?.premium_feature &&
              getDataFromStorage("role") === constants.Roles.learner
            )
              MenuBarHks.setFeature(true);

            Alert.setUserBatch(res.data.data);

            Alert.setRegistered(res.data?.data?.[0]?.registered);

            if (pathname === "/main/dashboard") {
              Alert.setIsJoinZoom(
                res.data.data.join_zoom
              ); /* TODO: Zoom Integration */

              if (res.data.data.length === 1) {
                if (res.data.data[0].type === constants.BATCH_TYPE.TESTING) {
                  let courseNav =
                    typeof res.data.data[0].courses == "string"
                      ? JSON.parse(res.data.data[0].courses)
                      : res.data.data[0].courses;

                  if (courseNav.length > 1) {
                    MenuBarHks.handleSetLocalStorage(res.data.data[0]);
                    MenuBarHks.handleDashBoard();
                  } else {
                    MenuBarHks.handleSetLocalStorage(res.data.data[0]);
                    sessionStorage.setItem("lpId", courseNav[0].lpId);

                    if (courseNav[0].lpId == null) {
                      localStorage.setItem("hideBatch", true);
                      Alert.navigate("/main/cc");
                    } else {
                      localStorage.removeItem("hideBatch");
                      Alert.navigate("/main/dashboard/learningpath");
                    }
                  }
                } else {
                  MenuBarHks.handleSetLocalStorage(res.data.data[0]);
                  MenuBarHks.handleDashBoard();
                }
              } else if (res.data.data.length === 0) {
                Alert.setShowNotify({
                  show: true,
                  title: "Warning",
                  primaryButtonFunction: useCommonFunctionHks.handleUnAuthAlert,
                  msg: "You don't belong to any batch. Please contact Gradious Team.",
                });
              } else {
                if (localStorage.getItem("batchid") != null) {
                  let batch = res.data.data.filter(
                    (data) =>
                      data.id === parseInt(localStorage.getItem("batchid"))
                  );

                  if (batch && batch.length === 1) {
                    MenuBarHks.handleSetLocalStorage(batch[0]);

                    if (
                      res.data.data.length === 1 &&
                      batch[0].type === constants.BATCH_TYPE.TESTING
                    ) {
                      Alert.navigate("/main/dashboard/learningpath");
                    } else {
                      if (batch == null) {
                        localStorage.setItem("hideBatch", true);
                        Alert.navigate("/main/cc");
                      } else {
                        localStorage.removeItem("hideBatch");
                        Alert.navigate("/main/dashboard");
                        MenuBarHks.handleDashBoard();
                      }
                    }
                  }
                } else {
                  MenuBarHks.handleSetLocalStorage(res.data.data[0]);
                  MenuBarHks.handleDashBoard();
                }
              }
            }
          }
        })
        .catch((error) => {
          useCommonFunctionHks.getCatchBlockDetails(error);
        })
        .finally
        // () => Alert.setIsLoaded(false)
        ();
    }
  }, []);

  // console.log("\n\n\n\n\n------------jobs-----------\n\n\n",enabledFeatures);

  return (
    <div className="menuBarMainContainer">
      {(Alert.isLoaded ||
        (pathname.includes("learningpath") && Alert.courseData == null)) && (
          <Loading overlay/>
        )}
      <Sidebar className="menuBarMainSideBar">
        <div className="menuBarMainInnerDiv" onClick={MenuBarHks.handleCompany}>
          {<CompanyLogo />}
        </div>
        <div
          active={pathname.includes("landing")}
          className="menuBarSubMenuListDashboard"
          onClick={() => {
            if (isPreviewLp) return;
            Alert.navigate("main/landing");
            localStorage.removeItem("batchid");
            localStorage.removeItem("batchname");
          }}
        >
          {/* <MenuSvgIcon menuId={constants.MENU_ICON.DASHBOARD} /> */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.91 5.68774H8.7725C8.6399 5.68774 8.51272 5.74042 8.41895 5.83419C8.32517 5.92794 8.2725 6.05512 8.2725 6.18774V13.8927C8.2729 14.0252 8.3257 14.1522 8.41937 14.2458C8.51307 14.3395 8.64002 14.3923 8.7725 14.3927H13.91C14.0425 14.3923 14.1694 14.3395 14.2631 14.2458C14.3568 14.1522 14.4096 14.0252 14.41 13.8927V6.18774C14.41 6.05512 14.3573 5.92794 14.2635 5.83419C14.1698 5.74042 14.0426 5.68774 13.91 5.68774Z"
              fill="#FCF4E7"
            />
            <path
              d="M13.91 1.40674H8.7725C8.6399 1.40674 8.51272 1.45942 8.41895 1.55319C8.32517 1.64695 8.2725 1.77413 8.2725 1.90674V4.47423C8.2729 4.60673 8.3257 4.73368 8.41937 4.82735C8.51307 4.92103 8.64002 4.97385 8.7725 4.97423H13.91C14.0425 4.97385 14.1694 4.92103 14.2631 4.82735C14.3568 4.73368 14.4096 4.60673 14.41 4.47423V1.90674C14.41 1.77413 14.3573 1.64695 14.2635 1.55319C14.1698 1.45942 14.0426 1.40674 13.91 1.40674Z"
              fill="#ACBC80"
            />
            <path
              d="M7.06 9.11279H1.925C1.64886 9.11279 1.425 9.33667 1.425 9.61279V13.8928C1.425 14.1689 1.64886 14.3928 1.925 14.3928H7.06C7.33615 14.3928 7.56 14.1689 7.56 13.8928V9.61279C7.56 9.33667 7.33615 9.11279 7.06 9.11279Z"
              fill="#ACBC80"
            />
            <path
              d="M7.06 1.40674H1.92501C1.85928 1.40651 1.79415 1.41928 1.73339 1.44433C1.67262 1.46938 1.61741 1.50619 1.57093 1.55267C1.52446 1.59914 1.48764 1.65435 1.46259 1.71512C1.43754 1.77589 1.42478 1.84101 1.42501 1.90674V7.88925C1.42501 8.02185 1.47769 8.14902 1.57145 8.2428C1.66522 8.33655 1.7924 8.38925 1.92501 8.38925H7.06C7.1926 8.38925 7.31978 8.33655 7.41355 8.2428C7.50732 8.14902 7.56 8.02185 7.56 7.88925V1.90674C7.56023 1.84101 7.54745 1.77589 7.5224 1.71512C7.49738 1.65435 7.46055 1.59914 7.41407 1.55267C7.3676 1.50619 7.31238 1.46938 7.25163 1.44433C7.19085 1.41928 7.12572 1.40651 7.06 1.40674Z"
              fill="#FCF4E7"
            />
          </svg>

          <p className="dash-name">{isPreviewLp ? Alert?.courseData?.courses[0]?.lpname ?? localStorage.getItem("batchname") : "Dashboard"}</p>
        </div>
        {!isPreviewLp && <Menu
          transitionDuration={1000}
          className={`menuBarMainMenu ${Alert.showBlink ? "withAttendance" : ""}`}
          renderExpandIcon={({ open }) => (
            <span>
              {open ? <MinusIconSvg type={2} /> : <PlusIconSvg type={3} />}
            </span>
          )}
        >
          {!localStorage.getItem("hideBatch") && (
            <SubMenu
              label="Learning"
              className="menuBarSubMenuBar"
              defaultOpen={
                pathname.includes("landing") || pathname.includes("dashboard")
              }
            >
              {Alert.userBatch.length > 0 &&
                Alert.userBatch.map((batch) => (
                  <Tooltip key={batch.id} title={batch.name} placement="right">
                    <MenuItem
                      key={batch.id}
                      onClick={() => MenuBarHks.handleBatch(batch)}
                      prefix={
                        <MenuSvgIcon menuId={constants.MENU_ICON.BATCHES} />
                      }
                      className={`menuBarSubMenuList ${batch.id === parseInt(localStorage.getItem("batchid"))
                        ? "activeBatch"
                        : ""
                        }`}
                      active={
                        batch.id === parseInt(localStorage.getItem("batchid"))
                      }
                      ref={
                        batch.id === parseInt(localStorage.getItem("batchid"))
                          ? MenuBarHks.activeBatchRef
                          : null
                      }
                    >
                      {batch.name}
                    </MenuItem>
                  </Tooltip>
                ))}
            </SubMenu>
          )}

          {((MenuBarHks.feature && showPracticeMenu)||isPremiumCompany) && (
            <SubMenu
              label="Practice"
              className="menuBarSubMenuBar"
              defaultOpen={
                pathname.includes("cc") ||
                pathname.includes("mock") ||
                pathname.includes("interview")
              }
            >

              {(enabledFeatures.includes("coding_challenges")) &&
                getDataFromStorage("role") !== constants.Roles.parent && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("cc")}
                    onClick={() => Alert.navigate("main/cc")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.CODING_CHALLENGE} />}
                  >
                    Coding Challenges
                  </MenuItem>
                )}

            </SubMenu>
          )}

          {((MenuBarHks.feature && (enabledFeatures.includes("mcq") ||
                enabledFeatures.includes("descriptive") ||
                enabledFeatures.includes("coding_challenge_test") ||
                enabledFeatures.includes("video_test")) && !useCommonFunctionHks.checkBatchType() &&
                getDataFromStorage("role") !== constants.Roles.parent )) && (
            <SubMenu
              label="Mock Tests"
              className="menuBarSubMenuBar"
              defaultOpen={
                pathname.includes("cc") ||
                pathname.includes("mock") ||
                pathname.includes("interview")
              }
            >
            
              {(enabledFeatures.includes("ai_interviews")) &&
                !useCommonFunctionHks.checkBatchType() &&
                getDataFromStorage("role") !== constants.Roles.parent && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("company_specific")}
                    onClick={() => Alert.navigate("main/company_specific/library")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.COMPANY_SPECIFIC} />}
                  >
                    Company Specific
                  </MenuItem>
                )}

                {!useCommonFunctionHks.checkBatchType() &&
                getDataFromStorage("role") !== constants.Roles.parent && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("technology_specific")}
                    onClick={() => Alert.navigate("main/technology_specific/library")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.TECHNOLOGY_SPECIFIC} />}
                  >
                    Technology Specific
                  </MenuItem>
                )}
             

              {(enabledFeatures.includes("mcq") ||
                enabledFeatures.includes("descriptive") ||
                enabledFeatures.includes("coding_challenge_test") ||
                enabledFeatures.includes("video_test")) &&
                !useCommonFunctionHks.checkBatchType() &&
                getDataFromStorage("role") !== constants.Roles.parent && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("mock")}
                    onClick={() => Alert.navigate("main/mock/library")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.VIDEO} />}
                  >
                    Mock interview
                  </MenuItem>
                )}

              {(enabledFeatures.includes("ai_interviews")) &&
                !useCommonFunctionHks.checkBatchType() &&
                getDataFromStorage("role") !== constants.Roles.parent && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("interview")}
                    onClick={() => Alert.navigate("main/interview/library")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.AI_INTERVIEW} />}
                  >
                    AI Interviews
                  </MenuItem>
                )}

            </SubMenu>
          )}


          {(((MenuBarHks.feature ||
            getDataFromStorage("role") === constants.Roles.parent) && showExploreMenu)|| isPremiumCompany) && (

              <SubMenu
                label="Explore"
                className="menuBarSubMenuBar"
                defaultOpen={
                  pathname.includes("jobs_internships") || pathname.includes("hackathons")
                }
              >

                {(enabledFeatures.includes("jobs_internships")) && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("jobs_internships")}
                    onClick={() => Alert.navigate("main/jobs")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.JOBS} />}
                  >
                    Jobs & Internships
                  </MenuItem>
                )}

                {(enabledFeatures.includes("hackathons")) && (
                  <MenuItem
                    className="menuBarSubMenuList"
                    active={pathname.includes("hackathons")}
                    onClick={() => Alert.navigate("main/hackathons")}
                    prefix={<MenuSvgIcon menuId={constants.MENU_ICON.HACKATHON} />}
                  >
                    Hackathons
                  </MenuItem>
                )}

              </SubMenu>
            )}

          {((!useCommonFunctionHks.checkBatchType() &&
            getDataFromStorage("role") !== constants.Roles.parent)) && (
              <SubMenu
                label="Doubts"
                className="menuBarSubMenuBar"
                defaultOpen={
                  pathname.includes("doubts") || pathname.includes("discussons")
                } 
              >
                <MenuItem
                  className="menuBarSubMenuList"
                  active={pathname.includes("doubts")}
                  onClick={() => Alert.navigate("main/doubts")}
                  prefix={<MenuSvgIcon menuId={constants.MENU_ICON.DOUBTS} />}
                >
                  Ask Doubts
                </MenuItem>
                
              </SubMenu>
            )}
            
        </Menu>}
        {/* {!isPreviewLp && <SharePublicProfileButton />} */}
        {!isPreviewLp && <MenuBarFooter />}
      </Sidebar>
      <main className="menuBarBody">
        <Outlet />
      </main>
    </div>
  );
}
